import { SxProps, Theme } from '@mui/material/styles';
import { useSessionStorage } from 'usehooks-ts';

import { MOBILE_APP_CLUB_CODE, ValidClubCode } from '../constants/mobileApp';

const gradientStyles: Record<ValidClubCode, string> = {
  '005':
    'linear-gradient(to right, #e31b23, #a11a5e, #5b2d8e, #1b3fa0, #0a2f9a)',
  '212':
    'linear-gradient(to right, #e31b23, #a11a5e, #5b2d8e, #1b3fa0, #0a2f9a)',
  '006': '#377d9f',
};

const useClubCardStyles = (): SxProps<Theme> => {
  const [clubCode] = useSessionStorage(MOBILE_APP_CLUB_CODE, '');

  if (!clubCode || !(clubCode in gradientStyles)) {
    return {};
  }

  const gradient = gradientStyles[clubCode as ValidClubCode];

  return {
    boxShadow: 'none',
    borderRadius: 4,
    overflow: 'hidden',
    position: 'relative',
    pb: '4px',
    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      height: '4px',
      background: gradient,
    },
  };
};

export default useClubCardStyles;
